import client from "lib/apolloClient/client";

import {
  getOrganizationAcademicYearsQuery,
  getAcademicYearDetailsQuery,
} from "./Query";

export const getOrganizationAcademicYearsFromCache = ({
  organizationId,
  termsFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationAcademicYearsQuery,
      variables: {
        id: organizationId,
        termsFilters,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getAcademicYearDetailsFromCache = ({
  academicYearId,
  curriculumProgramIds,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery(
      {
        query: getAcademicYearDetailsQuery,
        variables: {
          id: academicYearId,
          curriculumProgramIds,
        },
      },
      true
    );
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const writeOrganizationAcademicYearsToCache = ({
  organizationId,
  data,
}) => {
  try {
    client.writeQuery({
      query: getOrganizationAcademicYearsQuery,
      variables: {
        id: organizationId,
      },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};

export const writeAcademicYearDetailsToCache = ({
  academicYearId,
  curriculumProgramIds,
  data,
}) => {
  try {
    client.writeQuery({
      query: getAcademicYearDetailsQuery,
      variables: {
        id: academicYearId,
        curriculumProgramIds,
      },
      data,
    });
  } catch (e) {
    console.error(e);
  }
};
